"use strict";

import "angular";
import "angular-resource";
import "angular-translate";

//Directive
import PersonalMessagingDirective from "./PersonalMessagingDirective";
import PersonalMessagingController from "./PersonalMessagingController";
import PersonalMessagingService from "./PersonalMessagingService";
import AccuCodeService from "../layout/service/AccuCodeService";
import PersonalMessagingFactory from "./PersonalMessagingFactory.js";

const PersonalMessagingModule = angular
    .module("PersonalMessagingModule", ["ngResource"])
    .controller("personalMessagingController", PersonalMessagingController)
    .service("personalMessagingService", PersonalMessagingService)
    .service("AccuCodeService", AccuCodeService)
    .factory("personalMessagingFactory", PersonalMessagingFactory)
    .directive("personalMessaging", PersonalMessagingDirective);

export default PersonalMessagingModule;
